
































import {
  defineComponent,
  ref,
  computed,
  getCurrentInstance,
} from '@vue/composition-api';
import { getIsPortalEnabledStatus } from '@/appsync/service/SystemSettingQueryService';
import { usePortalAppBar } from '@/composables/use-portal-app-bar';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import CommonSetting, {
  Props as CommonSettingProps,
} from '@/containers/templates/CommonSetting.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n, useI18n } from '@/plugins/i18n/i18n';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { LoginInfo } from '@/types/type';
import { _BooleanEnum2boolean } from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

export default defineComponent({
  components: {
    PortalAppBar,
    CommonSetting,
    PageNotFound,
    ErrorMessagePageTemplate,
  },
  setup(props, context) {
    const title = useI18n('common.commonSetting');
    const vm = getCurrentInstance();

    const loading = ref(true);
    const hasSettingsPermission = ref(false);
    const isPortalEnabled = ref(true);
    const userInfo = ref(loginUserModule.userInfo);
    const notEnabledImgAltMessage: String = 'Page Not Enabled';
    const notEnabledImgName: String = 'page-not-enabled';
    const notEnabledImgWidth: String = '250px';
    const notEnabledImgHeight: String = '186px';
    const notEnabledTitleText = useI18n('pageNotEnabled.titleText');
    const notEnabledSubText = useI18n('pageNotEnabled.subText');

    async function refreshLoginInfo() {
      await refreshStores(commonModule.loginInfo);
      userInfo.value = loginUserModule.userInfo;
      if (vm) {
        hasSettingsPermission.value = (vm as any).$hasPermission(
          'menus.settings'
        );
      }

      loading.value = false;
    }
    refreshLoginInfo();

    async function getPortalEnabledStatus() {
      const loginInfo: LoginInfo = commonModule.loginInfo;
      isPortalEnabled.value = await getIsPortalEnabledStatus(
        loginInfo.tenant,
        loginInfo.landscape
      );
    }
    getPortalEnabledStatus();

    const tabs = (): CommonSettingProps['tabs'] => {
      const commonTabs = [
        {
          title: i18n.tc('commonSetting.tabs.general'),
          to: PAGE_PATH_BY_NAME.commonsettingGeneral,
        },
        {
          title: i18n.tc('commonSetting.tabs.webApi'),
          to: PAGE_PATH_BY_NAME.commonsettingWebApi,
        },
      ];

      if (isPortalEnabled.value) {
        commonTabs.splice(1, 0, {
          title: i18n.tc('commonSetting.tabs.announcement'),
          to: PAGE_PATH_BY_NAME.commonsettingAnnouncement,
        });
      }
      commonTabs.push({
        title: i18n.tc('commonSetting.tabs.role'),
        to: PAGE_PATH_BY_NAME.commonsettingRole,
      });
      commonTabs.push({
        title: i18n.tc('commonSetting.tabs.userManagement'),
        to: PAGE_PATH_BY_NAME.commonsettingUserManagement,
      });

      return commonTabs;
    };

    return {
      ...usePortalAppBar(),
      tabs: computed(tabs),
      title,
      loading,
      userInfo,
      hasSettingsPermission,
      notEnabledImgAltMessage,
      notEnabledImgName,
      notEnabledImgWidth,
      notEnabledImgHeight,
      notEnabledTitleText,
      notEnabledSubText,
      isPortalEnabled,
    };
  },
});
